import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './Historique.css';

const Historique = () => {
  const { currentUser } = useAuth();
  const [historique, setHistorique] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const historiqueRef = ref(database, 'rendezvous/' + currentUser.uid);
    
    onValue(historiqueRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const historiqueList = Object.entries(data).map(([id, value]) => ({
          id,
          ...value
        }));
        
        const aujourdhui = new Date();
        const passes = historiqueList.filter(r => new Date(r.date) < aujourdhui);
        setHistorique(passes.sort((a, b) => new Date(b.date) - new Date(a.date)));
      } else {
        setHistorique([]);
      }
      setLoading(false);
    });
  }, [currentUser]);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="historique-container">
      <h2>Historique des demandes</h2>
      
      {historique.length === 0 ? (
        <p className="no-data">Aucun historique disponible</p>
      ) : (
        <div className="historique-list">
          {historique.map((demande) => (
            <div key={demande.id} className="historique-card">
              <div className="historique-header">
                <span className="historique-date">
                  {new Date(demande.date).toLocaleDateString('fr-FR')}
                </span>
                <span className={`statut-badge ${demande.statut}`}>
                  {demande.statut}
                </span>
              </div>
              
              <div className="historique-details">
                <p><strong>De:</strong> {demande.adresseDepart}</p>
                <p><strong>À:</strong> {demande.adresseArrivee}</p>
                <p><strong>Service:</strong> {demande.typeService}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Historique;